const inherits =
  typeof Object.create === 'function'
    ? // implementation from standard node.js 'util' module
      function (ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true,
          },
        });
      }
    : // old school shim for old browsers
      function (ctor, superCtor) {
        ctor.super_ = superCtor;
        const TempCtor = function () {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      };

export default inherits;
